import ReactDOM from "react-dom";
export const reactInitialRender = (elem, node, callback) => {
    return ReactDOM.hydrate(elem, node, callback);
};
